import { PlusIcon } from "lucide-react";

import { Link } from "@/components/Link";
import type { MaterialSpec } from "@/features/admin/types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function MaterialsTable({
  materials,
}: {
  materials: MaterialSpec[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "materials",
    materials,
    [
      {
        field: "name",
        headerName: "Name",
        cellRenderer: (params) => (
          <Link to="/admin/materials/$id/edit" params={{ id: params.data.id }}>
            {params.data.name}
          </Link>
        ),
      },
      {
        field: "code",
        headerName: "Code",
      },
      {
        field: "type",
        headerName: "Type",
      },
    ],
    { sideBar: undefined },
  );
  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/materials/new" asButton>
          <PlusIcon data-slot="icon" />
          Add material
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
